import React from "react";
import { MusicHallTransferSlipContainerStyled } from "./styled";
import { connect } from "react-redux";
import { withRouter } from "navigations/withRouter";
import queryString from "query-string";
import { portalService } from "apiServices";
import momentTZ from "moment-timezone";
import moment from "moment";
import * as XLSX from "xlsx";
import {
  ACKNOWLEDGED_STATUS,
  PAYMENT_METHOD,
  RENDER_ACKNOWLEDGED_STATUS,
  RENDER_PAYMENT_METHOD,
} from "utils/functions/musicHall";
import { ROUTE_PATH } from "utils/constants/routePath";
import { IMG_PATH } from "utils/constants/imgPath";
import { RenderCommaMoney } from "utils/functions/FormatMoney";
import { BtnComfirmSlipTranfersWidget } from "widgets";
import { Displays, Inputs, Tables } from "components";

class MusicHallTransferSlipContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    const query = this.buildQueryString();
    this.fetchData(query);
  }

  fetchData = async (query) => {
    let res = await portalService.GET_ROOM_BOOKING_PAYMENT_LIST(query);
    if (res && res.status === 200) {
      this.setState({
        data: res.data,
        isLoading: false,
        isBgLoading: false,
      });
    }
  };
  // QUERY FLOW
  // =========================================
  // =========================================
  buildQueryString = (additionalParams = {}) => {
    const { router } = this.props;
    const urlParams = queryString.parse(router.location.search);
    const defaultQuery = {
      limit: 20,
      has_payments: true,
      date_type: "paid_at",
      // start_date: moment().startOf("month").format("YYYY-MM-DD"),
      // end_date: moment().endOf("month").format("YYYY-MM-DD"),
    };
    const finalParams = {
      ...defaultQuery,
      ...urlParams,
      ...additionalParams,
    };
    const cleanParams = Object.entries(finalParams)
      .filter(
        ([key, value]) => value !== null && value !== undefined && value !== ""
      )
      .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
    const query = `?${Object.entries(cleanParams)
      .map(([key, value]) => `${key}=${value}`)
      .join("&")}`;
    router.navigate(`${ROUTE_PATH.MUSIC_HALL_BOOKING_TRANFER_SLIP}${query}`);
    return query;
  };
  handleFilterKeyword = (e) => {
    const queryParams =
      typeof e === "string" ? queryString.parse(e.replace("?", "")) : e;
    this.handleJoinQuery(queryParams);
  };
  handlePageClick = (e) => {
    this.handleJoinQuery({ page: e.selected + 1 });
  };
  handlePerPageChange = (limit) => {
    this.handleJoinQuery({ limit, page: 1 });
  };
  handleJoinQuery = (additionalQuery) => {
    const query = this.buildQueryString(additionalQuery);
    this.setState({
      isLoading: true,
    });
    this.fetchData(query);
  };

  handleExport = async () => {
    let query = this.buildQueryString();
    query += `&pagination=false`;
    this.setState({
      isBgLoading: true,
    });
    let res = await portalService.GET_ROOM_BOOKING_PAYMENT_LIST(query);
    if (res && res.status === 200) {
      let wb = XLSX.utils.book_new();
      let ws_name = "SheetJS";

      /* make worksheet */
      let ws_data = res.data.docs.reduce((result, e, i) => {
        let params1 = [
          i + 1,
          momentTZ(e.paid_at).tz("Asia/Bangkok").format("DD-MM-YY"),
          RENDER_PAYMENT_METHOD(e.payment_method).labelTh,
          e.booker_first_name,
          e.booker_last_name,
          e.booker_phone,
          e.booker_email,
          e.event_name,
          e.room_name_th,
          IMG_PATH + e.slip_upload,
          RenderCommaMoney(e.transfer_amount),
          RENDER_ACKNOWLEDGED_STATUS(e.acknowledged_status).labelTh,
        ];
        result.push(params1);
        return result;
      }, []);
      let columnTemp = [
        {
          name: "No",
          wch: 4,
        },
        {
          name: "Payments Received Date",
          wch: 16,
        },

        {
          name: "สถานะการชำระเงิน",
          wch: 16,
        },
        {
          name: "ชื่อ",
          wch: 25,
        },
        {
          name: "นามสกุล",
          wch: 25,
        },
        {
          name: "Phone Number",
          wch: 25,
        },
        {
          name: "Email",
          wch: 25,
        },
        {
          name: "Event Name",
          wch: 25,
        },
        {
          name: "Room",
          wch: 25,
        },
        {
          name: "รูปสลิปโอนเงิน",
          wch: 12,
        },
        {
          name: "จำนวนเงิน",
          wch: 20,
        },
        {
          name: "Status",
          wch: 20,
        },
      ];
      /* make worksheet */
      ws_data.splice(
        0,
        0,
        columnTemp.map((e) => e.name)
      );
      let ws = XLSX.utils.aoa_to_sheet(ws_data);
      let wscols = columnTemp.map((e) => {
        return { wch: e.wch };
      });
      ws["!cols"] = wscols;
      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, ws_name);
      XLSX.writeFile(
        wb,
        `music-hall-booking-transfer-slip-${moment()
          .tz("Asia/Bangkok")
          .format("DD/MM/YYYY")}.xlsx`
      );
      this.setState({
        isBgLoading: false,
      });
    }
  };

  handleDownloadSlip = async () => {
    let query = this.buildQueryString();
    query += `&pagination=false`;
    this.setState({
      isBgLoading: true,
    });
    try {
      let res = await portalService.GET_ROOM_BOOKING_SLIP_DOWNLOAD(query);
      if (res) {
        const blob = new Blob([res], { type: "application/zip" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `music-hall-transfer-slips-${moment()
            .tz("Asia/Bangkok")
            .format("DD-MM-YYYY")}.zip`
        );
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
    }
    this.setState({
      isBgLoading: false,
    });
  };

  render() {
    const { router, authenRedux } = this.props;
    const { isBgLoading, isLoading, data } = this.state;
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find(
          (e) => e.menu_key === "music-hall-booking"
        );
    return (
      <MusicHallTransferSlipContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        <div className="filter_layout">
          <Inputs.InputFilter
            theme_standard_input_filter
            dataFilter={dataFilter(router.location?.search)}
            btnLabel="ค้นหา"
            onQueryFilter={this.handleFilterKeyword}
            onExport={
              permission &&
              (permission.is_export || permission.is_export_condition)
                ? () => this.handleExport(permission)
                : false
            }
            onSave={this.handleDownloadSlip}
            batnSaveLabel={"Download"}
          />
        </div>
        {isLoading ? (
          <Displays.Loading theme_standard_loading />
        ) : (
          <Tables.Standard
            columns={columns({
              onSuccess: () => this.fetchData(this.buildQueryString()),
            })}
            data={data.docs}
            showPagination
            pagination={{
              last_page: data.totalPages,
              current_page: data.page,
              total: data.totalDocs,
              per_page: data.limit,
            }}
            handlePageClick={this.handlePageClick}
            onChangePerPage={this.handlePerPageChange}
          />
        )}
      </MusicHallTransferSlipContainerStyled>
    );
  }
}

const dataFilter = (query) => {
  let initialValues = queryString.parse(query);
  return [
    {
      accessor: "name",
      length: "311px",
      filter: {
        fieldQuery: "name",
        defaultValue: initialValues["name"],
        type: "text",
        label: "Name",
        placeholder: "Name",
      },
    },
    {
      accessor: "phone",
      length: "311px",
      filter: {
        fieldQuery: "phone",
        defaultValue: initialValues["phone"],
        type: "text",
        label: "Phone Number",
        placeholder: "Phone Number",
      },
    },
    {
      accessor: "payment_method",
      length: "311px",
      filter: {
        fieldQuery: "payment_method",
        defaultValue: initialValues["payment_method"],
        type: "dropdown",
        label: "สถานะการชำระเงิน",
        placeholder: "All",
        options: [{ label: "All", value: "" }, ...PAYMENT_METHOD],
      },
    },
    {
      accessor: "acknowledged_status",
      length: "311px",
      filter: {
        fieldQuery: "acknowledged_status",
        defaultValue: initialValues["acknowledged_status"],
        type: "dropdown",
        label: "สถานะ",
        placeholder: "All",
        options: [{ label: "All", value: "" }, ...ACKNOWLEDGED_STATUS],
      },
    },
    {
      accessor: "group_by",
      filter: {
        label: "Time Period",
        fieldQuery: "group_by",
        type: "dateGroup",
        initialValues: {
          level1: !initialValues["group_by"]
            ? "all"
            : initialValues["group_by"],
          level2:
            initialValues["group_by"] === "date_range"
              ? {
                  startDate: new Date(initialValues["start_date"]),
                  endDate: new Date(initialValues["end_date"]),
                }
              : false,
        },
        options: [
          { label: "All", value: "all" },
          { label: "วันนี้", value: "today" },
          { label: "เดือนนี้", value: "this_month" },
          { label: "เดือนที่แล้ว", value: "last_month" },
          { label: "ช่วงเวลา", value: "date_range" },
        ],
      },
    },
  ];
};

const columns = ({ onSuccess }) => [
  {
    Header: <div style={{ textAlign: "left" }}>Payments Received Date</div>,
    accessor: "paid_at",
    Cell: (props) =>
      momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY"),
  },
  {
    Header: <div style={{ textAlign: "left" }}>สถานะการชำระเงิน</div>,
    accessor: "payment_method",
    Cell: (props) => {
      const renderStatus = RENDER_PAYMENT_METHOD(props.value);
      return (
        <div style={{ color: renderStatus.txtColor }}>
          {renderStatus.labelTh}
        </div>
      );
    },
  },
  {
    Header: <div style={{ textAlign: "left" }}>ชื่อ</div>,
    accessor: "booker_first_name",
    Cell: (props) => props.value,
  },
  {
    Header: <div style={{ textAlign: "left" }}>นามสกุล</div>,
    accessor: "booker_last_name",
    Cell: (props) => props.value,
  },
  {
    Header: <div style={{ textAlign: "left" }}>Phone Number</div>,
    accessor: "booker_phone",
    Cell: (props) => props.value,
  },
  {
    Header: <div style={{ textAlign: "left" }}>Email</div>,
    accessor: "booker_email",
    Cell: (props) => props.value,
  },
  {
    Header: <div style={{ textAlign: "left" }}>Event Name</div>,
    accessor: "event_name",
    Cell: (props) => props.value,
  },
  {
    Header: <div style={{ textAlign: "left" }}>Room</div>,
    accessor: "room_name_th",
    Cell: (props) => props.value,
  },
  {
    Header: <div style={{ textAlign: "left" }}>รูปสลิปโอนเงิน</div>,
    accessor: "slip_upload",
    Cell: (props) => (
      <a
        href={IMG_PATH + props.value}
        target="_blank"
        rel="noopener noreferrer"
      >
        Link
      </a>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>จำนวนเงิน</div>,
    accessor: "transfer_amount",
    Cell: (props) => RenderCommaMoney(props.value),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Status</div>,
    accessor: "acknowledged_status",
    Cell: (props) => {
      const renderStatus = RENDER_ACKNOWLEDGED_STATUS(props.value);
      return (
        <Displays.StatusLabel
          txtColor={renderStatus.txtColor}
          bg={renderStatus.bgColor}
          label={renderStatus.labelTh}
        />
      );
    },
  },
  {
    Header: <div style={{ textAlign: "center" }}>ยืนยันการโอน</div>,
    accessor: "confirm",
    Cell: (props) =>
      props.row.original.acknowledged_status !== "1" ? (
        ""
      ) : (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <BtnComfirmSlipTranfersWidget
            {...props.row.original}
            onSuccess={onSuccess}
          />
        </div>
      ),
  },
];

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(MusicHallTransferSlipContainer));
